import { useEffect, useState } from "react";
import { useForm } from "../../../hooks";
import {
  usePatientSurgeryStore,
  useTPatientSurgeryVisibility,
  useFormMessages,
  useFormEventStore,
} from "../../hooks";
import {
  PatientSurgeryEvaluationAccordion,
  PatientSurgeryResultAccordion,
  ScheduleProcedureAccordion,
  ScheduleAssessmentAccordion,
} from "../accordions";
import {
  QuizFinalModal,
  AssessmentScheduledModal,
  DefineSessionsOriginModal,
} from "../modals";
import { InfoStepAlert } from "../alerts";

const initialFormData = {};

const initialFormValidations = {};

export const PatientSurgeryInfocard = () => {
  // Datos del hook ----------------------------------------//
  const {
    // Props
    patientSurgery,

    // Methods
    startSendQuizSatisfaction,
    startDefineSessions,
  } = usePatientSurgeryStore();

  const {
    // Props
    isLoading,
    message,
  } = useFormEventStore();

  const {
    showProcedureTab,
    showAssessmentTab,
    showQuizFinal,
    showAssessmentScheduledModal,
    showInfoStepAlert,
    showDefineSessionsOriginModal,
    tabIndex,
  } = useTPatientSurgeryVisibility();

  const { evaluations } = patientSurgery.data;

  // States ------------------------------------------------//
  const [activeIndex, setActiveIndex] = useState(tabIndex);
  const [isQuizFinalModal, setIsQuizFinalModal] = useState(showQuizFinal);
  const [isAssessmentScheduledModal, setIsAssessmentScheduledModal] = useState(
    showAssessmentScheduledModal
  );
  const [quizFinalAnswers, setQuizFinalAnswers] = useState([]);
  const [isDefineSessionsOriginModal, setIsDefineSessionsOriginModal] =
    useState(showDefineSessionsOriginModal);
  const [formData, setFormData] = useState(initialFormData);
  const [formValidations, setFormValidations] = useState(
    initialFormValidations
  );
  const [validateForm, setValidateForm] = useState(false);

  // Formulario --------------------------------------------//
  const { formState, formValidation, onInputChange, isFormValid, onResetForm } =
    useForm(formData, formValidations);

  const {
    setFormSubmitted,
    showErrorMessage,
    showSuccessMessage,
    messageText,
  } = useFormMessages({
    message,
  });

  // Funciones ---------------------------------------------//
  const handleViewAssessmentScheduled = () => {
    setIsAssessmentScheduledModal(false);
    setActiveIndex(4);
  };

  const handleSubmitQuizFinal = () => {
    setFormSubmitted(true);
    startSendQuizSatisfaction(quizFinalAnswers);
  };

  const eventsDefinedByChange = (event) => {
    const { name, value } = event.target;

    setFormData(() => {
      const updated = {
        ...formState,
        [name]: value,
      };

      if (value === "PATIENT") {
        updated.numberEvents = "";
        updated.state = "ASSESSMENT_MADE";
      } else if (value === "DOCTOR") {
        updated.numberEvents = null;
        updated.state = "QUIZ_ANSWERED";
      }

      return updated;
    });

    setFormValidations(() => {
      const updated = {
        ...formValidations,
      };

      if (value === "PATIENT") {
        updated.numberEvents = [
          (val) => (val ?? "").toString().trim().length > 0,
          "Escribe el número de sesiones",
          (val) => parseInt(val, 10) > 0,
          "El número de sesiones debe ser mayor a 0",
          (val) => parseInt(val, 10) <= 4,
          "El número de sesiones debe ser menor a 5",
        ];
      } else if (value === "DOCTOR") {
        delete updated.numberEvents;
      }

      return updated;
    });
  };

  const onSubmit = () => {
    setValidateForm(true);
    if (isFormValid) {
      setFormSubmitted(true);
      startDefineSessions(formState);
    }
  };

  const propsToModal = {
    isLoading,
    quizFinalAnswers,
    setQuizFinalAnswers,
    showErrorMessage,
    messageText,
  };

  const propsForm = {
    validateForm,
    formState,
    formValidation,
    isLoading,
    showErrorMessage,
    messageText,
    eventsDefinedByChange,
    onInputChange,
  };

  // Efectos -----------------------------------------------//
  useEffect(() => {
    setActiveIndex(tabIndex);
    setIsQuizFinalModal(showQuizFinal);
    setIsAssessmentScheduledModal(showAssessmentScheduledModal);
    setIsDefineSessionsOriginModal(showDefineSessionsOriginModal);
  }, [
    tabIndex,
    showQuizFinal,
    showAssessmentScheduledModal,
    showDefineSessionsOriginModal,
  ]);

  useEffect(() => {
    if (showSuccessMessage) {
      if (isQuizFinalModal) setIsQuizFinalModal(false);
      if (isDefineSessionsOriginModal) setIsDefineSessionsOriginModal(false);
    }
  }, [showSuccessMessage]);

  // useEffect(() => {
  //   console.log("quizFinalAnswers", quizFinalAnswers);
  // }, [quizFinalAnswers]);

  // useEffect(() => {
  //   console.log(formState);
  // }, [formState]);

  // useEffect(() => {
  //   console.log(formValidation);
  // }, [formValidation]);

  useEffect(() => {
    if (showDefineSessionsOriginModal) {
      setFormData(() => {
        const updated = {
          eventsDefinedBy: "",
          numberEvents: "",
          state: "",
        };

        return updated;
      });

      setFormValidations(() => {
        const updated = {
          eventsDefinedBy: [
            (val) => (val ?? "").toString().trim().length > 0,
            "Selecciona una opción",
          ],
        };

        return updated;
      });
    }
  }, [showDefineSessionsOriginModal]);

  return (
    <>
      {showInfoStepAlert && <InfoStepAlert />}

      <div className="w-full">
        <ul className="nav nav-tabs">
          <li className="nav-item">
            <button
              className={`nav-link ${activeIndex === 1 ? "active" : ""}`}
              aria-current="page"
              onClick={() => setActiveIndex(1)}
            >
              Encuesta
            </button>
          </li>
          <li className="nav-item">
            <button
              className={`nav-link ${activeIndex === 2 ? "active" : ""}`}
              aria-current="page"
              onClick={() => setActiveIndex(2)}
            >
              Resultados
            </button>
          </li>
          {showProcedureTab && (
            <li className="nav-item">
              <button
                className={`nav-link ${activeIndex === 3 ? "active" : ""}`}
                aria-current="page"
                onClick={() => setActiveIndex(3)}
              >
                Procedimiento
              </button>
            </li>
          )}
          {showAssessmentTab && (
            <li className="nav-item">
              <button
                className={`nav-link ${activeIndex === 4 ? "active" : ""}`}
                aria-current="page"
                onClick={() => setActiveIndex(4)}
              >
                Valoración
              </button>
            </li>
          )}
        </ul>
        <div className="card">
          <div className="card-body">
            {activeIndex === 1 && (
              <PatientSurgeryEvaluationAccordion
                evaluations={evaluations.EVALUATION}
              />
            )}
            {activeIndex === 2 && <PatientSurgeryResultAccordion />}
            {activeIndex === 3 && <ScheduleProcedureAccordion />}
            {activeIndex === 4 && <ScheduleAssessmentAccordion />}
          </div>
        </div>
      </div>

      <QuizFinalModal
        isOpen={isQuizFinalModal}
        setIsOpen={setIsQuizFinalModal}
        onSubmit={handleSubmitQuizFinal}
        props={propsToModal}
      />

      <AssessmentScheduledModal
        isOpen={isAssessmentScheduledModal}
        setIsOpen={setIsAssessmentScheduledModal}
        handleViewAssessmentScheduled={handleViewAssessmentScheduled}
      />

      <DefineSessionsOriginModal
        isOpen={isDefineSessionsOriginModal}
        setIsOpen={setIsDefineSessionsOriginModal}
        onSubmit={onSubmit}
        propsForm={propsForm}
      />
    </>
  );
};
